import styles from './index.module.less';
import React from 'react';

const Index: React.FC<any> = ({ title, desc }) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.desc}>{desc}</div>
      <ul className={styles.tags}>
        <li className={styles.active}>Fully anonymous</li>
        <li>Instant action</li>
        <li>Zero Hassle</li>
      </ul>
    </div>
  );
};

export default Index;
